<template>
    <div>
        <mensajeSistema></mensajeSistema>
        <v-dialog v-model="getConfiguracion.activarModal" persistent scrollable max-width="90%">
            <v-card>
                <v-card-title class="btn_otro py-5">
                    <v-row class="d-flex justify-space-between py-0">
                        Calendario de actividades del estudiante
                        <v-btn fab dark x-small class="btn_style3" @click="cerrarCalendario"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>
  
                <v-divider></v-divider>

                <v-card-text>
                    <v-row class="fill-height">
                        <v-col class="pt-0">
                            <v-sheet height="64">

                                <v-toolbar flat>
                                    <v-col class="d-flex justify-center">
                                        <v-btn fab dark x-small class="btn_block_style2 mr-4 ml-16" @click="prev">
                                            <v-icon>fa-chevron-left</v-icon>
                                        </v-btn>


                                        <v-toolbar-title>{{title}}</v-toolbar-title>


                                        <v-btn fab dark x-small class="btn_block_style2 ml-4" @click="next">
                                            <v-icon>fa-chevron-right</v-icon>
                                        </v-btn>
                                    </v-col>
                                     <v-menu bottom right class="d-flex text-align-start">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                            class="btn_block_style2" dark 
                                            v-on="on"
                                            >
                                                <span>{{ typeToLabel[type] }}</span>
                                                <v-icon right>fa-chevron-down</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list>
                                            <v-list-item @click="type='day'">
                                                <v-list-item-title>Día</v-list-item-title>
                                            </v-list-item>

                                            <v-list-item @click="type='week'">
                                                <v-list-item-title>Semana</v-list-item-title>
                                            </v-list-item>

                                            <v-list-item @click="type='month'">
                                                <v-list-item-title>Mes</v-list-item-title>
                                            </v-list-item>

                                            <!-- <v-list-item @click="type = '4day'">
                                                <v-list-item-title>4 days</v-list-item-title>
                                            </v-list-item> -->
                                        </v-list>
                                    </v-menu>
                    
                                </v-toolbar>
                            </v-sheet>


                            <v-sheet height="700" class="mr-6" >
                                <v-calendar
                                style="border: 1px solid #e7e7e7"
                                ref="calendar"
                                v-model="focus"
                                color="primary"
                                :events="combinedEvents"
                                :event-color="getEventColor"
                                :now="today"
                                :type="type"
                                @click:event="showEvent"
                                @click:more="viewDay"
                                @click:date="viewDay"
                                @change="updateRange"

                                :short-weekdays="false"
                                :weekdays="diaHabil"
                                :short-months="false"
                                :short-intervals="false"

                                :first-interval="intervals.first"
                                :interval-minutes="intervals.minutes"
                                :interval-count="intervals.count"
                                :interval-height="intervals.height"
                                ></v-calendar>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>




        <!-- modal ver detalles de la actividad del calendario -->
        <v-dialog v-model="selectedOpen" :activator="selectedElement" scrollable max-width="400px">
            <v-card>
                <v-card-title :style="{background : selectedEvent.color_curso , color:'#fff'}">
                    <v-row class="d-flex justify-space-between py-2">
                        Detalle de la actividad
                        <v-btn fab dark x-small class="btn_style3" @click="selectedOpen=false"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-div v-if="selectedEvent.nombre_seccion">
                    <v-row class="d-flex justify-center mt-2 mb-2">
                        <v-chip color="blue" class="font-weight-black" dark>
                            Nivel: {{selectedEvent.desc_nivel}}
                            Grado: {{selectedEvent.desc_grado}}
                            Sección: {{selectedEvent.nombre_seccion}}
                        </v-chip>

                    </v-row>

                    <v-row class="d-flex justify-center pt-2">

                        <v-avatar size="30" :color="selectedEvent.color_curso">
                            <v-icon dark small>{{selectedEvent.icono_curso}}</v-icon>
                        </v-avatar>

                        <v-chip color="white font-weight-black">{{selectedEvent.desc_curso}}</v-chip>

                    </v-row>


                    <v-col class="mt-3">
                       <p class="black--text"><span class="font-weight-black">Unidad:</span> {{selectedEvent.nombre_tema}}</p>
                        <p class="black--text"><span class="font-weight-black">Tema:</span> {{selectedEvent.nombre_clase}}</p>
                        <p class="black--text"><span class="font-weight-black">Fecha:</span> {{selectedEvent.fecha_actividad}}</p>
                        <p class="black--text"><span class="font-weight-black">Actividad asignada por el docente: </span>
                            <v-chip class="primary" @click="
                                                    dowload(
                                                    ruta_api +
                                                        selectedEvent.ruta_actividad +
                                                        selectedEvent.archivo_actividad,
                                                    selectedEvent.ruta_actividad,
                                                    selectedEvent.archivo_actividad
                                                    )
                                                ">
                                {{selectedEvent.archivo_actividad}}
                            </v-chip></p>
                           <!--<p class="black--text"><span class="font-weight-black">Actividad Doc:</span><v-chip class="primary"><a :href="ruta_api+selectedEvent.ruta_actividad+selectedEvent.archivo_actividad" target="_blank" style="color:#fff;text-decoration:none;">{{selectedEvent.archivo_actividad}}</a></v-chip></p>-->

                        <p class="black--text" v-if="selectedEvent.archivo_alumno===null && selectedEvent.ruta_alumno ===null">
                            <span class="font-weight-black" >Actividad enviada por el estudiante: </span> 
                            <v-chip >No se ha enviado</v-chip> 
                        </p>
                       <p class="black--text" v-else><span class="font-weight-black" >Actividad enviada por el estudiante:</span>
                            <v-chip class="primary">
                                <a :href="ruta_api+selectedEvent.ruta_alumno+selectedEvent.archivo_alumno" style="color:#fff;text-decoration:none" target="_blank">{{selectedEvent.archivo_alumno}}</a>
                            </v-chip>
                        </p>
                        <p class="black--text"><span class="font-weight-black">Estudiante:</span> {{selectedEvent.nombre_apellido_alumno}}</p>
                        <p class="black--text"><span class="font-weight-black">Docente:</span> {{selectedEvent.nombre_apellido_docente}}</p>
                    </v-col>
                </v-div>

                    <div v-else>
                            <v-card color="grey lighten-4" min-width="150px" heigth="200px" flat>
                                <v-toolbar :color="selectedEvent.color" dark>
                                    <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>

                                <v-card-text>
                                    <v-form>
                                        {{ selectedEvent.name }} - {{ selectedEvent.details }}
                                    </v-form>
                                </v-card-text>
                            </v-card>
                        </div>
                </v-card-text>
            </v-card>
        </v-dialog>









    </div>
</template>

<script>

    import axios,{API_URL} from "../../../../helpers/axios";
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

    export default {
        name:'modalClaseCalendario',
        props:['datos'],
        /*
        props:{
            FX
        }
        */


        data: () => ({
            datoLogin: sessionStorage, // variables de sesion del usuario

            //today: new Date().toISOString().substr(0,10),
            //focus: new Date().toISOString().substr(0,10),
            ruta_api: API_URL +'/',  // ruta del servidor
            today: new Date().toISOString().substr(0,10),
            focus: '',
            type: 'month',

            typeToLabel: {
                month: 'Mes',
                week: 'Semana',
                day: 'Día',
                //'4day': '4 Days',
            },

            // orden de semana de lunes a domingo (dias del calendario)
            weekdays:[1, 2, 3, 4, 5, 6, 0],

            /* orden del calendario en vista de semana y dia
            hora de inicio, division de renglones, bloque de horas, medida de renglones*/
            intervals: {
                first: 11,
                minutes: 30,
                count: 30,
                height: 40,

            },

            start: null,
            end: null,

            events: [],
            name: null,
            details: null,
            color: null,

            // ventana de detalles del item
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,


            nivelDoc   :[],
            gradoDoc   :[],
            areaDoc    :[],
            cursoDoc   :[],
            seccionDoc :[],
            progDocente    :[],
            diaHabil:[],
            events2:[]

        }),


        computed: {
            ...mapGetters('progDocente', ['getConfiguracion']),
            ...mapState({
            idsDiasSeleccionados: "idsDiasSeleccionados",
            fechasFeriado: "fechasFeriado",
         }),

         combinedEvents() {
            // Combinar los dos conjuntos de eventos en uno solo para renderizados
            return [...this.events, ...this.events2];
        },


            title () {
                const { start, end } = this
                if (!start || !end) {
                return ''
                }

                const startMonth = this.monthFormatter(start)
                // const endMonth = this.monthFormatter(end)
                // const suffixMonth = startMonth === endMonth ? '' : endMonth

                const startYear = start.year
                // const endYear = end.year
                // const suffixYear = startYear === endYear ? '' : endYear

                const startDay = start.day
                // const endDay = end.day

                switch (this.type) {
                case 'month':
                    return `${startMonth} ${startYear}`
                case 'week':
                    return `${startMonth} ${startDay} de ${startYear}`
                        
                /* case '4day':
                    return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}` */

                case 'day':
                    return `${startMonth} ${startDay} de ${startYear}`
                }
                return ''
            },

            monthFormatter () {
                return this.$refs.calendar.getFormatter({
                    timeZone: 'UTC', month: 'long',
                })
            },
        },


        mounted () {
            ///this.$refs.calendar.checkChange()
            //this.title()
             this.getEvents(this.datos)


            // posicionar el calendario con el scroll en una hora en especifico al abrirlo
            //this.$refs.calendar.scrollToTime('08:00')
        },

        methods: {
            ...mapMutations('progDocente', ['setActivarCalendario', 'setCloseCalendario']),

            ...mapActions({
            getFechasFeriado: "getFechasFeriado",
            getDiasHabiles: "getDiasHabiles",
            }),

            async dowload(url, url_validated, filename) {
                await this.$Files.existFile(
                    {
                    url:
                        this.ruta_api +
                        "academico/progDocente/obtenerActividad/" +
                        url_validated.split("/").splice(3).join("/") +
                        filename,
                    },
                    async (res) => {
                    if (!res.success) {
                        return this.setEnviarMens({
                        tipo: "E",
                        mensaje: res.message,
                        tiempo: null,
                        });
                    }
                    await this.$Files.dowload(
                        {
                        url,
                        filename,
                        },
                        (res) => {
                        if (!res.success) {
                            this.setEnviarMens({
                            tipo: "E",
                            mensaje: res.message,
                            tiempo: null,
                            });
                        }
                        }
                    );
                    }
                );
                },
            // componente de  calendario
            cerrarCalendario(){
                 this.$emit('closeCalendar');
                this.type = 'month'
            },


            async getEvents(parametros){
                let params = parametros
                try {
                    const events = []
                    let response = await axios.post('/academico/padre/all/alu/act/',params);
                    this.progAlumno = response.data

                  console.log('Cargandooo data'+JSON.stringify(this.progAlumno));

                       //1.- Se dispara el action , me traigo el estado y lo igualo a this.diasHabil
                       this.$store.dispatch('getDiasHabiles').then(() => {
                        this.diaHabil = this.idsDiasSeleccionados.idsDiasSeleccionados[0].dias_seleccionados;
                    })

                    //for (let i = 0; i < eventCount; i++) {
                    this.progAlumno.forEach(doc => {

                    

                        let eventoData = doc
                        eventoData.id = doc.id
                        eventoData.name = `${doc.nombre_clase} TEMA: ${doc.nombre_tema} ;
                                            CURSO: ${doc.desc_curso}

                                            <br> Nivel: ${doc.desc_nivel} &nbsp; Grado: ${doc.desc_grado} &nbsp; Sección: ${doc.nombre_seccion}`
                        //eventoData.name = `${doc.nombre_clase} ${doc.nombre_tema} <br> ${doc.desc_nivel}  ${doc.desc_grado} ${doc.nombre_seccion}`
                         if(doc.archivo_alumno===null){
                             eventoData.color = 'error'
                         }else{
                            eventoData.color = doc.color_curso 
                         }
                        
                        eventoData.details = `<span class="font-weight-black">${doc.desc_nivel} </span>
                                            <span class="font-weight-black">${doc.desc_grado}  </span> `

                        eventoData.start = `${doc.fecha_actividad} ${doc.hora_fin_actividad}`
                        eventoData.end = `${doc.fecha_actividad} ${doc.hora_fin_actividad}`

                        events.push(eventoData)

                    });

                      this.$store.dispatch("getFechasFeriado").then(() => {
                    const eventos = this.fechasFeriado.fechasFeriado.map((evento) => ({
                        name: evento.name,
                        start: evento.start,
                        end: evento.end,
                        color: evento.color,
                        details: evento.details,
                        id: evento.id,
                    }));

                        this.events2 = eventos;
                        console.log("eventos2", this.events2);
                    }) 

                    this.events = events

                }

                catch (error) {
                    //console.log(error);
                }

            },


            viewDay ({ date }) {
                this.focus = date
                this.type = 'day'
            },

            getEventColor (event) {
                return event.color
            },


            prev () {
                this.$refs.calendar.prev()
            },


            next () {
                this.$refs.calendar.next()
            },


            showEvent ({ nativeEvent, event }) {
                    const open = () => {
                    this.selectedEvent = event
                    this.selectedElement = nativeEvent.target
                    setTimeout(() => this.selectedOpen = true, 10)
                }

                if (this.selectedOpen) {
                    this.selectedOpen = false
                    setTimeout(open, 10)
                }
                else {
                    open()
                }

                nativeEvent.stopPropagation()
            },


            updateRange ({ start, end }) {
                /* const events = []

                const min = new Date(`${start.date}T00:00:00`)
                const max = new Date(`${end.date}T23:59:59`)
                const days = (max.getTime() - min.getTime()) / 86400000
                const eventCount = this.rnd(days, days + 20)

                for (let i = 0; i < eventCount; i++) {
                    const allDay = this.rnd(0, 3) === 0
                    const firstTimestamp = this.rnd(min.getTime(), max.getTime())
                    const first = new Date(firstTimestamp - (firstTimestamp % 900000))
                    const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
                    const second = new Date(first.getTime() + secondTimestamp)

                    events.push({
                        name: this.names[this.rnd(0, this.names.length - 1)],
                        start: this.formatDate(first, !allDay),
                        end: this.formatDate(second, !allDay),
                        color: this.colors[this.rnd(0, this.colors.length - 1)],
                    })
                } */

                this.start = start
                this.end = end
                //this.events = events
            },


            /* nth (d) {
                return d > 3 && d < 21
                ? 'th'
                : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
            }, */


            rnd (a, b) {
                return Math.floor((b - a + 1) * Math.random()) + a
            },


            formatDate (a, withTime) {
                return withTime
                ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
                : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
            },



            showIntervalLabel (interval) {
                return interval.minute === 0
            },

        },
    }
</script>

